import * as React from 'react';

export default function HeaderLogo({
  controller,
}: {
  controller: { logoClicked: (event: React.MouseEvent<SVGSVGElement>) => void };
}) {
  const onClick = (event: React.MouseEvent<SVGSVGElement>) =>
    controller.logoClicked?.(event);

  return (
    <div style={{ color: '#FFF' }}>
      <svg
        className="student-header-logo"
        onClick={onClick}
        width="31"
        height="40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="m14.736 16.483-2.863 4.934a1.8 1.8 0 0 1-1.55.893h-5.7c-.63 0-1.234-.341-1.55-.893L.236 16.483a1.802 1.802 0 0 1 0-1.785l2.837-4.934a1.8 1.8 0 0 1 1.55-.893h5.7a1.8 1.8 0 0 1 1.55.893l2.864 4.934a1.802 1.802 0 0 1 0 1.785Zm-4.413 10.079h-5.7c-.63 0-1.234.34-1.55.892L.236 32.388a1.802 1.802 0 0 0 0 1.785l2.837 4.935c.316.55.92.892 1.55.892h5.7c.63 0 1.235-.341 1.55-.892l2.837-4.935a1.802 1.802 0 0 0 0-1.785l-2.837-4.934a1.798 1.798 0 0 0-1.55-.892ZM25.69 0h-5.7a1.8 1.8 0 0 0-1.55.892l-2.863 4.935a1.803 1.803 0 0 0 0 1.785l2.837 4.934c.315.551.92.892 1.55.892h5.726c.63 0 1.235-.34 1.55-.892l2.837-4.934a1.802 1.802 0 0 0 0-1.785L27.24.892A1.798 1.798 0 0 0 25.69 0Zm0 17.69h-5.7c-.63 0-1.234.341-1.55.893l-2.863 4.934a1.802 1.802 0 0 0 0 1.785l2.837 4.934a1.8 1.8 0 0 0 1.55.893h5.726a1.8 1.8 0 0 0 1.55-.893l2.837-4.934a1.802 1.802 0 0 0 0-1.785l-2.837-4.934a1.798 1.798 0 0 0-1.55-.893Z"
        />
      </svg>
    </div>
  );
}
